import { z } from 'zod';

export const INVALID_ERR = 'Must contain only alphanumeric characters, hyphens, and underscores';
export const TOO_LONG = 'Must be less than 255 characters long';

const graphiteMetricRegex = /^[A-Za-z0-9_-]+$/;
export const statsPrefixSchema = z
  .string()
  .max(255, TOO_LONG)
  .regex(graphiteMetricRegex, INVALID_ERR)
  .or(z.literal(''));
